import React, {Component} from 'react';
import {BusinessUnitRow} from "./BusinessUnitRow";
import {Button} from "reactstrap";
import {AddBusinessUnitModal} from "./AddBusinessUnitModal";
import {Spinner} from "../Spinner";
import {TableToggleSection} from "../elements/TableToggleSection";
import { withTranslation } from 'react-i18next';

class BusinessUnitListClass extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showNotActive: false,
            showFinished: false
        };

        this.handleToggleActiveNotActive = this.handleToggleActiveNotActive.bind(this);
        this.handleToggleFinished = this.handleToggleFinished.bind(this);
    }

    handleToggleFinished() {
        this.setState({showFinished:!this.state.showFinished});
    }

    handleToggleActiveNotActive() {
        this.setState({showNotActive:!this.state.showNotActive});
    }

    render() {
        const { t } = this.props;
        const content = this.props.businessUnits === null ? this.renderLoading() : this.renderTable();

        return (
            <div className="section-body-item -widest box">
                <header className="box-header">
                    <h2 className="box-title">{t('business_unit_list.title')}</h2>

                    <div>
                        <Button className="-alt" onClick={() => {
                            this.addBusinessUnitModal.toggle()
                        }}>{t('business_unit_list.add_control_line')}</Button>
                        <AddBusinessUnitModal ref={
                            instance => {
                                this.addBusinessUnitModal = instance;
                            }} afterSuccessfulSubmit={this.props.afterSuccessfulBusinessUnitSubmit}
                                              clientId={this.props.clientId} clientName={this.props.clientName}
                        />
                    </div>

                </header>
                {content}
            </div>
        )
    }

    renderHeader() {
        const { t } = this.props;
        return <thead>
        <tr>
            <th>{t('business_unit_list.name')}</th>
            <th width={"130px"}>{t('business_unit_list.accounts')}</th>
            <th>{t('business_unit_list.period')}</th>
            <th>{t('business_unit_list.type')}</th>
            <th>{t('business_unit_list.budget')}</th>
            <th>{t('business_unit_list.goals')}</th>
            <th>{t('business_unit_list.status')}</th>
        </tr>
        </thead>;
    }

    renderLoading() {
        return (
            <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        )
    }

    renderNoActiveBusinessUnits() {
        const { t } = this.props;
        const noActiveQ = this.getBusinessUnitNoActiveQuantity();
        if(noActiveQ === 0)
            return null;

        return [
            <TableToggleSection tableColumns="7" onToggle={this.handleToggleActiveNotActive} text={t('business_unit_list.view_inactive_control_lines', { count: noActiveQ })} isExpanded={false} />,
            this.state.showNotActive ? this.businessUnitRows(false, null) : null
        ];
    }

    renderFinishedBusinessUnits() {
        const { t } = this.props;
        const finishedQ = this.getBusinessUnitActiveAndFinishedQuantity();
        if(finishedQ === 0)
            return null;

        return [
            <TableToggleSection tableColumns="7" onToggle={this.handleToggleFinished} text={t('business_unit_list.view_finished_control_lines', { count: finishedQ })} isExpanded={false} />,
            this.state.showFinished ? this.businessUnitRows(true, true) : null
        ];
    }

    renderTable() {

        return <div className="table-box">
            <table className="table table-striped">
                {this.renderHeader()}
                <tbody>
                {this.businessUnitRows(true, false)}
                {this.renderFinishedBusinessUnits()}
                {this.renderNoActiveBusinessUnits()}
                </tbody>
            </table>
        </div>;

    }

    getBusinessUnitNoActiveQuantity() {
        return this.props.businessUnits.filter((businessUnit) => (businessUnit.active === false)).length
    }

    getBusinessUnitActiveAndFinishedQuantity() {
        return this.props.businessUnits.filter((businessUnit) => (businessUnit.active === true && businessUnit.is_eventual_and_it_is_finished === true)).length
    }

    businessUnitRows(onlyActiveWithValue, justFinished) {
        return this.props.businessUnits.filter((businessUnit) => (businessUnit.active === onlyActiveWithValue && (justFinished === null || (justFinished === businessUnit.is_eventual_and_it_is_finished)))).map((businessUnit) =>
            <BusinessUnitRow key={businessUnit.id} businessUnit={businessUnit} onStatusChange={this.props.doBusinessUnitStatusChange} onDelete={this.props.doBusinessUnitDelete} />
        );
    }
}

export const BusinessUnitList = withTranslation()(BusinessUnitListClass);
export default BusinessUnitList;
